import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { WalletProvider } from './context/WalletContext';
import { BetSlipProvider } from './context/BetSlipContext';
import ScrollToTop from './components/layout/ScrollToTop'; 
import HomePage from './pages/Home';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import VerifyEmail from './pages/auth/VerifyEmail';
import EmailVerification from './pages/auth/EmailVerification';
import Signup from './pages/auth/Signup';
import SportsPage from './pages/SportsPage';
import BetslipPage from './pages/BetslipPage';
import LiveBettingPage from './pages/LiveBettingPage';
import CasinoPage from './pages/CasinoPage';
import WalletPage from './pages/WalletPage';
import ProfilePage from './pages/ProfilePage';
import KycVerification from './pages/kyc/KycVerification';
import MatchDetailPage from './pages/MatchDetailPage';
import BetHistoryPage from './pages/BetHistoryPage';
import DepositPage from "./pages/DepositPage";

function App() {
  return (
    <AuthProvider>
    <WalletProvider>
    <BetSlipProvider>
      <Router>
        <div className="App">
          <ScrollToTop /> 
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify-email" element={<EmailVerification />} />
            <Route path="/success-page" element={<VerifyEmail />} />
            <Route path="/register" element={<Signup />} />
            <Route path="/sports" element={<SportsPage />} />
            <Route path="/betslip" element={<BetslipPage />} />
            <Route path="/live" element={<LiveBettingPage />} />
            <Route path="/casino" element={<CasinoPage />} />
            <Route path="/wallet" element={<WalletPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/kyc" element={<KycVerification />} />
            <Route path="/match/:fixtureId" element={<MatchDetailPage />} />
            <Route path="/bet-history" element={<BetHistoryPage />} />
            <Route path="/deposit" element={<DepositPage />} />
            
            {/* Redirect all unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </BetSlipProvider>
    </WalletProvider>
    </AuthProvider>
  );
}

export default App;